<ng-content></ng-content>
<ng-container *ngIf="providerGroups?.length">
  <ng-container *ngFor="let providerGroup of providerGroups">
    <ng-container
      *ngIf="
        getProductVendor(
          entryGroupService.getFirstEntry(providerGroup?.entryGroups)
        )
      "
    >
      <h2
        class="eyebrow--s"
        data-cy="bundle-provided-by-label"
        *ngIf="displayTitle"
      >
        {{ "checkoutOrderConfirmation.providedBy" | cxTranslate }}&nbsp;
        <dcp-provided-by-tooltip
          data-cy="bundle-provided-by-tooltip"
          [vendorAddress]="
            getProductVendorAddress(
              entryGroupService.getFirstEntry(providerGroup?.entryGroups)
            )
          "
        ></dcp-provided-by-tooltip>
      </h2>
    </ng-container>
    <div *ngFor="let entryGroup of providerGroup.entryGroups">
      <dcp-entry-group
        [entryGroup]="entryGroup"
        [providerContractCount]="providerContractCount"
        [derivativesTmpl]="derivativesTmpl"
        [groupTotalTmpl]="groupTotalTmpl"
        [recurringTotalTmpl]="recurringTotalTmpl"
        [paymentTmpl]="paymentTmpl"
        [providedOrderEntriesTmpl]="providedOrderEntriesTmpl"
        [termsAndConditionsTmpl]="termsAndConditionsTmpl"
      >
      </dcp-entry-group>
    </div>
  </ng-container>
</ng-container>
